import {useMediaStore} from "@/store/mediaStore";


export async function reloadMedia() {
    setTimeout(async () => {
        await useMediaStore().fetchMedia();
    }, 500);
}